/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} YearInputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} year" |
* | "other" | "{count} years" |
*
* @param {YearInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const year = /** @type {((inputs: YearInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<YearInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		const countPlural = registry.plural("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} year`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} years`);
		return /** @type {LocalizedString} */ ("year");
	}
	{
		const countPlural = registry.plural("fr", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} an`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} ans`);
		return /** @type {LocalizedString} */ ("year");
	}
});